<div class="btn-reserva-movil" [ngClass]="claseEntrada" *ngIf="mostrarBtn">
    <button data-bs-toggle="modal" href="#modalFormReserva" class="btn cmn-btncircle">
         {{ txtMostrar }}
    </button>
</div>

